module.exports = __webpack_public_path__ + "img/common_filter.42846f0a.svg";